import { push } from "connected-react-router";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import Entity from "../../shared/components/Entity";
import TextExpander from "../../shared/components/TextExpander";
import { allResourceTypeLabel } from "../../shared/utils";
import { roles } from "../actions";
import { PermissionShape, PolicyDetailsShape } from "../proptypes";
import selectors from "../selectors";

const PoliciesSummaryItem = ({
  policy,
  editPolicy,
  removePolicy,
  permissionsForPolicy,
  setCurrentRole,
  push
}) => {
  const {
    user,
    group,
    product,
    service,
    resourceType,
    resource,
    role
  } = policy;

  const permissions = permissionsForPolicy.map(p => ({
    id: p.$uri,
    text: p.summary
  }));

  let resourceLabel = resource ? resource.name : "-";
  if (resourceType && !resource.identifier) {
    resourceLabel = allResourceTypeLabel(resourceType.name);
  } else if (resourceType) {
    resourceLabel = `${resourceLabel} (${resourceType.name})`;
  }

  const entity = {
    $uri: group ? group.$uri : user.$uri,
    type: group ? "group" : "user",
    label: group ? group.name : user.username
  };

  return (
    <tr>
      <td colSpan="3" className="u-hide-text-overflow">
        <Link to={`/policies/groups/${entity.label}`}>
          <Entity type={entity.type}>{entity.label}</Entity>
        </Link>
      </td>
      <td colSpan="3" className="u-hide-text-overflow">
        <Link
          className="p-button--link"
          to={`/policies/services/${service.name}`}
        >
          {`${service.name} (${product.name})`}
        </Link>
      </td>
      <td colSpan="4" className="u-hide-text-overflow">
        {resourceLabel}
      </td>
      <td colSpan="5" className="u-hide-text-overflow">
        <button
          className="p-button--link"
          type="button"
          onClick={() => {
            setCurrentRole(role.$uri);
            push("/policies/roles");
          }}
        >
          {role.name}
        </button>
        <TextExpander list={permissions} />
      </td>
      <td colSpan="2" className="u-align--right">
        <button
          type="button"
          className="p-button--icon u-no-margin"
          onClick={() => editPolicy(policy, entity.label)}
        >
          <i className="p-icon--edit" />
        </button>
        <button
          type="button"
          className="p-button--icon u-no-margin--bottom"
          onClick={() => removePolicy(policy)}
        >
          <i className="p-icon--close" />
        </button>
      </td>
    </tr>
  );
};

PoliciesSummaryItem.propTypes = {
  push: PropTypes.func.isRequired,
  policy: PolicyDetailsShape.isRequired,
  editPolicy: PropTypes.func.isRequired,
  removePolicy: PropTypes.func.isRequired,
  permissionsForPolicy: PropTypes.arrayOf(PermissionShape).isRequired,
  setCurrentRole: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  permissionsForPolicy: selectors.permissions.getForPolicy(state, props)
});

const mapDispatchToProps = {
  setCurrentRole: roles.setCurrent,
  push
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PoliciesSummaryItem);
